export default "__VITE_ASSET__DatVFIZ7__"